import React, { useRef, useEffect } from 'react';
import { TabBarProps } from '../types';
import MenuItem from '../_partials/MenuItem';

import s from './HeaderMobile.scss';

const paddingLeft = parseInt(s['paddingLeft'], 10);

const HeaderMobile: React.FC<TabBarProps> = ({ items, activeMenuItem }) => {
  const navListRef = useRef<HTMLUListElement>(null);
  const activeItemRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const navRef = navListRef.current;
    const activeRouteRef = activeItemRef.current;
    if (!navRef || !activeRouteRef) {
      return;
    }

    navRef.scrollLeft = activeRouteRef.offsetLeft - paddingLeft;
  }, []);

  const setActiveItemRef = (pageType?: string) =>
    pageType === activeMenuItem
      ? (node: HTMLElement) => {
          activeItemRef.current = node;
        }
      : undefined;

  return (
    <header className={s['header']}>
      {items && (
        <ul className={s['nav-list']} ref={navListRef}>
          {items.map(menuItem => (
            <li key={menuItem.pageType} className={s['nav-list__item']}>
              <MenuItem
                menuItem={menuItem}
                isActive={activeMenuItem === menuItem.pageType}
                innerRef={setActiveItemRef(menuItem.pageType)}
              />
            </li>
          ))}
        </ul>
      )}
    </header>
  );
};
HeaderMobile.displayName = 'HeaderMobile';

export default HeaderMobile;
